import React from 'react';

// Toggle chips for hand-picking related posts; empty selection = automatic by topic.
export default function RelatedPicker({ options, value, onChange }) {
  const toggle = (slug) =>
    onChange(value.includes(slug) ? value.filter((s) => s !== slug) : [...value, slug]);
  return (
    <div data-testid="blog-related-picker">
      <label className="block text-xs font-semibold uppercase tracking-[0.18em] text-[#00b8ff] mb-2">
        Related reads (optional)
      </label>
      <p className="text-xs text-[#7a7a7a] mb-3">
        Pick posts to show first. Remaining spots fill automatically with the closest topics.
      </p>
      <div className="flex flex-wrap gap-2">
        {options.length === 0 && <span className="text-sm text-[#5a5a5a]">No other posts yet.</span>}
        {options.map((o) => {
          const on = value.includes(o.slug);
          const order = value.indexOf(o.slug) + 1;
          return (
            <button
              type="button"
              key={o.slug}
              onClick={() => toggle(o.slug)}
              data-testid={`related-chip-${o.slug}`}
              aria-pressed={on}
              className={`text-left text-sm rounded-full px-4 py-2 border transition-colors duration-200 ${
                on
                  ? 'border-[#00b8ff] bg-[#00b8ff]/10 text-[#f4efe6]'
                  : 'border-white/10 text-[#cfc8bb] hover:border-white/30'
              }`}
            >
              {on && <span className="text-[#00b8ff] font-semibold mr-2">{order}</span>}
              {o.title}
            </button>
          );
        })}
      </div>
    </div>
  );
}
